// Wortlaute der Erklärung „Tagesmeldungen“. Regeln für jeden Text: siehe ../help.js.
export default {
  title: "Tagesmeldungen",
  section: {
    DaySubmissionOverview: "Übersicht",
    DaySubmissionDetail: "Tagesmeldung",
    app: "In der App",
  },
  step: {
    intro: { text: "Hier stehen die Tage, die Mitarbeiter aus der App an die Bauleitung gesendet haben." },
    filter: {
      text: "Die Chips filtern nach Status, Offen ist vorgewählt. Wie viele noch zu erledigen sind, zeigt die Zahl in der Navigation.",
    },
    row: { text: "Die Zeile zeigt Tag, Baustelle und Absender. Ein Klick öffnet die Tagesmeldung." },
    head: {
      text: "Baustelle, Arbeitszeit und Pause, wie sie gesendet wurden, und wer den Tag gesendet hat. Ohne Baustelle wählen Sie sie beim Übernehmen.",
    },
    origin: {
      text: "Die Karte zeigt, wo das Gerät beim Aufnehmen war, dazu die Baustellen in der Nähe. Fehlt der Standort, steht hier, ob die App ihn noch nachreicht.",
    },
    weather: {
      text: "Das Wetter Stunde für Stunde. Die drei markierten Stunden kommen in [[cr:den/die/das]] [[cr]]. Darunter steht, was der Mitarbeiter zum Wetter gesagt hat.",
    },
    comments: { text: "Kommentare schreibt der Absender in der App, auch nachträglich. Sie erscheinen hier." },
    entries: {
      text: "Die übrigen Einträge stehen nach Abschnitten wie im Bericht, so wie sie gesendet wurden. Ändern lässt sich hier nichts.",
    },
    readiness: {
      text: "Hier wird aus der Tagesmeldung ein Bericht, oder Sie verwerfen sie. Der Bericht öffnet sich gefüllt im Editor, Sie ergänzen ihn und speichern.",
    },
    actions: {
      text: "Hier wird aus der Tagesmeldung [[cr:ein/eine/ein]] [[cr]] oder [[hwr:ein/eine/ein]] [[hwr]]. Oder Sie verwerfen sie.",
    },
    gap: {
      text: "Was dem Bericht fehlt, steht beim Eintrag. Sie ergänzen es im Bericht, bevor Sie ihn speichern.",
    },
    "app-record": {
      text: "In der App erzählen Mitarbeiter ihren Tag, statt ihn zu tippen. Die App fragt nach, was noch fehlt.",
    },
    "app-review": {
      text: "Zum Schluss prüfen sie die Einträge und senden den Tag an die Bauleitung. Dann steht er hier.",
    },
    "app-sent": { text: "Gesendete Tage sieht der Absender weiter in der App. Dort schreibt er seine Kommentare." },
    again: { text: "Diese Schaltfläche steht auf jeder Seite mit Erklärung. Ein Klick startet sie erneut." },
  },
  // Beschreibung der Bildschirme der App, die statt der App selbst gezeigt werden.
  image: {
    start: "Startseite der App mit der Frage nach dem Tag, Baustelle, Arbeitsbeginn und Mikrofon",
    listening: "Die App während der Aufnahme mit der nächsten Frage und den erkannten Einträgen",
    review: "Die Einträge zum Prüfen mit der Schaltfläche An Bauleitung senden",
    check: "Ein unsicherer Eintrag mit dem, was die App gehört hat",
    sent: "Ein gesendeter Tag in der App mit seinen Einträgen",
    sentComments: "Derselbe Tag mit dem Wetter und einem Kommentar des Absenders",
  },
}
